import { render } from "./ConstructorTypeMaker.vue?vue&type=template&id=d4a1256c"
import script from "./ConstructorTypeMaker.vue?vue&type=script&lang=js"
export * from "./ConstructorTypeMaker.vue?vue&type=script&lang=js"
script.render = render

export default script